import { combineReducers } from 'redux';
import { createSimpleRequestStatusReducer } from 'ContentData/helpers/reduxHelpers';
import { ECOMMERCE_CLEAR_OBJECTS_CACHE, ECOMMERCE_FETCH_OBJECTS, ECOMMERCE_FETCH_STORES } from 'ContentData/actions/ActionTypes';
const appStores = (state = {}, action) => {
  switch (action.type) {
    case ECOMMERCE_FETCH_STORES:
      {
        var _response$appStores;
        const {
          response
        } = action;
        if (!(response !== null && response !== void 0 && (_response$appStores = response.appStores) !== null && _response$appStores !== void 0 && _response$appStores.length)) return state;
        return response.appStores.reduce((acc, appStore) => {
          acc[appStore.appId] = appStore;
          return acc;
        }, {});
      }
    default:
      return state;
  }
};
const objectsCache = (state = {}, action) => {
  switch (action.type) {
    case ECOMMERCE_FETCH_OBJECTS:
      {
        const {
          response,
          options
        } = action;
        const {
          objectType
        } = options || {};
        if (!(response !== null && response !== void 0 && response.results) || !objectType) return state;
        const objectMap = response.results.reduce((acc, object) => {
          acc[object.hubSpotObjectId] = object;
          return acc;
        }, state[objectType] || {});
        return Object.assign({}, state, {
          [objectType]: objectMap
        });
      }
    case ECOMMERCE_CLEAR_OBJECTS_CACHE:
      {
        const {
          objectType
        } = action;
        return Object.assign({}, state, {
          [objectType]: {}
        });
      }
    default:
      return state;
  }
};
export default combineReducers({
  appStores,
  requestStatus: createSimpleRequestStatusReducer(ECOMMERCE_FETCH_STORES),
  objectsCache
});